// extracted by mini-css-extract-plugin
export default {"actions":"Button_actions__nEiRD","actions2":"Button_actions2__CEgIZ","actions3":"Button_actions3__11LED"};